export enum AffiliateWithdrawalTypesEnum {
  paypal = 'paypal',
  bank_transfer = 'bank_transfer',
}
